import { useContext } from 'react';
import { CalendarMode } from 'gen/ApiClient';
import { PreloadContext } from 'shared/context/PreloadContext';

export function useCalendarMode(): CalendarMode {
	const { calendarMode } = useContext(PreloadContext);
	return calendarMode;
}
